module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_botanical-cc7940e21ca5756ca8e31b373ac276e3.jpg";